<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">{{ pageTitle }}</h1>
        <p class="nd-page-kicker">Organize os tipos utilizados para solicitações e acompanhamento de exames.</p>
      </div>
    </header>

    <v-card class="nd-section-card">
      <v-form ref="form" v-model="formValid">
        <div class="nd-table-toolbar">
          <div>
            <div class="nd-table-toolbar__title">Dados do tipo de exame</div>
            <div class="nd-table-toolbar__subtitle">Informações principais do cadastro.</div>
          </div>
        </div>
        <div class="nd-form-grid">
          <v-text-field
            label="Nome do Tipo de Exame"
            v-model="examType.name"
            :rules="[rules.required]"
            outlined
            dense
           hide-details="auto"></v-text-field>
        </div>
        <div class="nd-form-actions">
          <v-btn id="btnBack" type="button" color="primary" outlined elevation="0" @click="$router.push('/tipos-de-exame')">
            Voltar
          </v-btn>
          <v-btn id="btnSave" type="button" color="primary" elevation="0" @click="save" :loading="loadingSave">
            Salvar
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ExamTypesDetails",

  data: () => ({
    examType: { id: null, name: "" },
    loadingPage: false,
    loadingSave: false,
    formValid: false,
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),

  computed: {
    pageTitle() {
      return this.examType.id ? "Detalhes do Tipo de Exame" : "Novo Tipo de Exame";
    },
    breadcrumbs() {
      return [
        { text: "Home", disabled: false, to: "/home", exact: true },
        { text: "Tipos de Exame", disabled: false, to: "/tipos-de-exame", exact: true },
        { text: this.examType.id ? "Detalhes" : "Novo", disabled: true, exact: true },
      ];
    },
  },

  async created() {
    const id = this.$route.params.id;
    if (id) {
      this.loadingPage = true;
      await this.load(id);
      this.loadingPage = false;
    }
  },

  methods: {
    async load(id) {
      try {
        const response = await axios.get(`/exam-types/${id}`);
        this.examType = { id: response.data.data.id, name: response.data.data.name };
      } catch (error) {
        this.$dialog.notify.error("Erro ao carregar tipo de exame.", { position: "top-right", timeout: 5000 });
      }
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      this.loadingSave = true;
      try {
        const payload = { name: this.examType.name };

        if (this.examType.id) {
          await axios.patch(`/exam-types/${this.examType.id}`, payload);
          this.$dialog.notify.success("Tipo de exame atualizado com sucesso!", { position: "top-right", timeout: 3000 });
        } else {
          await axios.post("/exam-types", payload);
          this.$dialog.notify.success("Tipo de exame criado com sucesso!", { position: "top-right", timeout: 3000 });
        }
        this.$router.push("/tipos-de-exame");
      } catch (error) {
        this.$dialog.notify.error("Erro ao salvar tipo de exame.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
